import React from 'react';

import { Title } from '../../../components/Title';
import { useOfferContext } from '../../../context';
import { getOfferSubtitle } from '../../../utils/computedProps/title/getOfferSubtitle';

export function TitleContainer() {
  const {
    title,
    subtitle: offerSubtitle,
    isTop,
    isNewbuilding,
    offer: { fullUrl, isCianPartner, externalOfferUrl, newbuilding, dailyrent },
  } = useOfferContext();
  const subtitle = dailyrent?.hotelData?.isHotel
    ? null
    : getOfferSubtitle({
        isNewbuilding,
        originalSubtitle: offerSubtitle,
        house: newbuilding?.house,
      });
  const starRating = dailyrent?.hotelData?.starRating;

  const href = isCianPartner ? externalOfferUrl : fullUrl;

  return <Title isTop={isTop} title={title} subtitle={subtitle} starRating={starRating} href={href} />;
}
